import { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import saveIcon from "../../../../../assets/design-revamp-company/system-boundary-subcategory/saveIcon.svg";
import removeIcon from "../../../../../assets/design-revamp-company/system-boundary-subcategory/removeIcon.svg";
import subcategoryIcon from "../../../../../assets/design-revamp-company/system-boundary-subcategory/subcategory-icon.svg";
import { useUserAccess } from "../../../../../components/WriteAccessContext";
import { useInvalidateQuery } from "../../../../../components/InvalidateQueryContext";
import WarningBox from "../WarningBox";
import FlowNumbersBox from "../FlowNumbersBox";
import SystemBoundary from "../HeaderBox/SystemBoundary";
const SubcategoryBox = ({
  subcategory = "",
  subcategoryDesc = "",
  subcategoryId = null,
  businessId,
  createSubcategoryApi,
  deleteSubcategoryApi,
  updateSubcategoryApi,
  onEdit,
  noDesc = false,
  customStyles,
  isNew = false,
  index = null,
  isLetter = false,
  baseSequence,
  isNormal = false,
  baseNumber = null,
  handleInvalidateAndReset,
  isNewSubcategory = false,
  showIcon,
  icon,
  showSystemBoundary,
  systemBoundaryProps,
}) => {
  const { t } = useTranslation();
  const [subcategoryCustom, setSubcategoryCustom] = useState(subcategory);
  const [subcategoryDescCustom, setSubcategoryDescCustom] =
    useState(subcategoryDesc);
  const { userAccess } = useUserAccess();
  const { triggerInvalidate } = useInvalidateQuery();
  const [showWarning, setShowWarning] = useState(false);

  useEffect(() => {
    if (subcategoryId && (subcategory || subcategoryDesc)) {
      setSubcategoryCustom(subcategory);
      setSubcategoryDescCustom(subcategoryDesc);
    }
  }, [subcategory, subcategoryDesc, subcategoryId]);

  useEffect(() => {
    if (typeof handleInvalidateAndReset === "function") {
      handleInvalidateAndReset(
        setSubcategoryCustom,
        setSubcategoryDescCustom,
        isNewSubcategory
      );
    }
  }, [handleInvalidateAndReset, isNewSubcategory]);

  const handleSave = () => {
    const subcategoryData = {
      businessId,
      ...(noDesc
        ? { building: subcategoryCustom }
        : { subcategory: subcategoryCustom }),
      subcategory_description: subcategoryDescCustom,
      objectId: subcategoryId,
      triggerInvalidate: triggerInvalidate,
    };
    if (subcategoryId) {
      updateSubcategoryApi(subcategoryData);
    } else {
      createSubcategoryApi(subcategoryData);
      setSubcategoryCustom("");
      setSubcategoryDescCustom("");
    }
  };

  const handleDelete = () => {
    if (subcategoryId) {
      const subcategoryData = {
        businessId,
        objectId: subcategoryId,
        triggerInvalidate: triggerInvalidate,
      };
      deleteSubcategoryApi(subcategoryData);
      setShowWarning(false);
    } else {
      setSubcategoryCustom("");
      setSubcategoryDescCustom("");
    }
  };

  const handleCancel = () => {
    setShowWarning(false);
  };
  return (
    <div
      style={{
        display: "flex",
        marginBottom: "12px",
        alignItems: "center",
        width: "100%",
        position: "relative",
        ...customStyles,
      }}
    >
      {!showIcon && (
        <div>
          <img
            src={subcategoryIcon}
            alt="Add New Subcategory Icon"
            width={30}
            height={30}
          />
        </div>
      )}
      <div className="subcategory-box">
        {userAccess === "write" && (
          <img
            src={removeIcon}
            alt="Remove Icon"
            width={20}
            height={20}
            className="sub-icon-remove"
            onClick={() => setShowWarning(true)}
          />
        )}
        <div style={{ display: "flex", width: "100%", alignItems: "center" }}>
          {showIcon && (
            <div style={{ marginRight: "20px" }}>
              <img src={icon} alt="Subgroup Icon" width={30} height={30} />
            </div>
          )}
          <div style={{ width: "100%" }}>
            <input
              value={subcategoryCustom}
              placeholder={t("CUSTOM_SUBCAT_NAME")}
              onChange={(e) => setSubcategoryCustom(e.target.value)}
              style={{ fontWeight: "bold" }}
            />
            {!noDesc && (
              <input
                value={subcategoryDescCustom}
                placeholder={t("CUSTOM_SUBCAT_DESC")}
                onChange={(e) => setSubcategoryDescCustom(e.target.value)}
              />
            )}

            {showSystemBoundary && (
              <SystemBoundary
                {...systemBoundaryProps}
                customStyles={{ marginLeft: 0, marginTop: "5px" }}
              />
            )}
          </div>
        </div>
        {userAccess === "write" && (
          <img
            src={saveIcon}
            alt="Save Icon"
            width={20}
            height={20}
            className="sub-icon-save"
            onClick={handleSave}
          />
        )}
        {index !== null && (
          <div
            style={{
              position: "absolute",
              bottom: "3px",
              right: "30px",
              paddingBottom: "5px",
            }}
          >
            <FlowNumbersBox
              isLetter={isLetter}
              baseSequence={baseSequence}
              index={index}
              isNormal={isNormal}
              baseNumber={baseNumber}
            />
          </div>
        )}
      </div>

      {showWarning && (
        <WarningBox
          message="Are you sure you want to delete this subcategory?"
          onConfirm={handleDelete}
          onCancel={handleCancel}
          showCancel={true}
        />
      )}
    </div>
  );
};

export default SubcategoryBox;
